/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.26.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ChangeOrderTradeCommandFromJSON(json) {
    return ChangeOrderTradeCommandFromJSONTyped(json, false);
}
export function ChangeOrderTradeCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'workorderId': !exists(json, 'workorderId') ? undefined : json['workorderId'],
        'newTrade': !exists(json, 'newTrade') ? undefined : json['newTrade'],
    };
}
export function ChangeOrderTradeCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'workorderId': value.workorderId,
        'newTrade': value.newTrade,
    };
}
